import { ReactElement, useEffect } from 'react';
import { UISubNav, useUINav } from '@/ui';
import { useMyCompanyUser } from '@/companies/hooks';
import { usePagesTranslation } from '../hooks';
import { MemberNextOfKinSettingsSection } from '@/companies/components/member-next-of-kin-settings-section';
import { MemberDescriptionSettingsSection } from '@/companies/components/member-description-settings-section';
import { MemberMedicalSettingsSection } from '@/companies/components/member-medical-settings-section';
import { hasFullAccess } from '@/companies/util/company-user-access';

export function EmergencyInformationSettingsPage(): ReactElement | null {
    const { t } = usePagesTranslation();
    const { setParts } = useUINav();
    useEffect(() => {
        setParts([
            {
                text: t('shared.labels.account')
            },
            { text: t('shared.labels.emergency_information') }
        ]);
    }, [setParts, t]);

    const companyUser = useMyCompanyUser();

    // You always see your own details in full, so the narrowing here is just
    // what lets the sections below take their data for granted.
    if (!companyUser || !hasFullAccess(companyUser)) {
        return null;
    }

    return (
        <div
            style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                padding: 32,
                gap: 24
            }}
        >
            <UISubNav title={t('shared.labels.emergency_information')} />
            {/* A user always has permission to edit their own details. */}
            <MemberDescriptionSettingsSection
                companyUser={companyUser}
                canEdit={true}
            />
            <MemberMedicalSettingsSection
                companyUser={companyUser}
                canEdit={true}
            />
            <MemberNextOfKinSettingsSection
                companyUser={companyUser}
                canEdit={true}
            />
        </div>
    );
}
